import {
  isEnvironmentDev,
  isEnvironmentTest,
  isEnvironmentStage,
  isEnvironmentProd
} from '../config'

const RE_WRITE_DEV_ORIGIN = 'https://web-app-v2.suki-dev.com'
const RE_WRITE_TEST_ORIGIN = 'https://web-app-v2.suki-test.com'
const RE_WRITE_STAGE_ORIGIN = 'https://web-app-v2.suki-stage.com'
const RE_WRITE_PRODUCTION_ORIGIN = 'https://web-app-v2.suki.ai'

const getRewriteBaseUrl = () => {
  if (isEnvironmentDev()) {
    return RE_WRITE_DEV_ORIGIN
  } else if (isEnvironmentTest()) {
    return RE_WRITE_TEST_ORIGIN
  } else if (isEnvironmentStage()) {
    return RE_WRITE_STAGE_ORIGIN
  } else if (isEnvironmentProd()) {
    return RE_WRITE_PRODUCTION_ORIGIN
  } else {
    return RE_WRITE_DEV_ORIGIN
  }
}

export { getRewriteBaseUrl }
